import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';
import cx from 'classnames';
import { noop } from 'lodash';
import styles from './Captcha.scss';

export default class Captcha extends Component {
  static propTypes = {
    captchaVerifyCallback: PropTypes.func.isRequired,
    mistrustedCallback: PropTypes.func,
  };

  static averageChallengeTime = 2500;

  static defaultProps = {
    captchaVerifyCallback: noop,
    mistrustedCallback: noop,
  };

  state = {
    mistrusted: false,
  };

  componentWillUnmount() {
    clearTimeout(this.initialMistrustedTimeoutId);
  }

  handleSuccess = (...args) => {
    this.props.captchaVerifyCallback(...args);
    this.setState({ mistrusted: false });
    this.props.mistrustedCallback(false);
    clearTimeout(this.initialMistrustedTimeoutId);
  };

  componentDidMount() {
    this.captcha.execute();
    // setting challenge as mistrusted if it took more than averageChallengeTime. Mostly
    // for showing ResetButton
    this.initialMistrustedTimeoutId = setTimeout(() => {
      this.setState({ mistrusted: true });
      this.props.mistrustedCallback(true);
    }, Captcha.averageChallengeTime);
  }

  forceReset = () => {
    if (!navigator.onLine) {
      location.reload();
    }
    this.captcha.reset();
    this.captcha.execute();
  };

  render() {
    return (
      <div>
        <ReCAPTCHA
          ref={el => {
            this.captcha = el;
          }}
          sitekey={process.env.RECAPTCHA_PUBLIC_KEY}
          size="invisible"
          onChange={this.handleSuccess}
        />
        {this.state.mistrusted && (
          <div className={styles.resetButtonContainer}>
            <span onClick={this.forceReset} className={cx(styles.resetButton)}>
              Pass challenge again
            </span>
          </div>
        )}
      </div>
    );
  }
}
